module.exports = __webpack_public_path__ + "img/Image_03.a2119be6.jpg";